import {useSearchOptions} from "../../../hooks/useSearchOptions";
import useListAddressURL from "./useListAddressUrl";

export const useAddressSearchOptions = () => {
  const {addressURL} = useListAddressURL();
  const options = useSearchOptions(addressURL, ["city", "state", "country", "zip_code"]);

  const searchOptions = [
    {
      category: {label: "City", value: "city"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.city,
    },
    {
      category: {label: "State", value: "state"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.state,
    },
    {
      category: {label: "Country", value: "country"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.country,
    },
    {
      category: {label: "Zip Code", value: "zip_code"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.zip_code,
    },
    {
      category: {label: "Is Mailing", value: "is_mailing"},
      operator: ["="],
      options: [
        {label: "true", value: true},
        {label: "false", value: false},
      ],
    },
    {
      category: {label: "Is Billing", value: "is_billing"},
      operator: ["="],
      options: [
        {label: "true", value: true},
        {label: "false", value: false},
      ],
    },
    {
      category: {label: "Is Shipping", value: "is_shipping"},
      operator: ["="],
      options: [
        {label: "true", value: true},
        {label: "false", value: false},
      ],
    },
  ];

  return {searchOptions};
};
